<oly-modal-view
  [blackBody]="true"
  [dialogRef]="dialogRef"
  headerTitle="System Info"
  [showCloseButton]="true"
>
  <ul>
    <li class="oly-util--mb-20">
      <span class="oly-util--db oly-util--fs-20 oly-util--fw-700">Model</span>
      <span>{{ APP_NAME }}</span>
    </li>
    <li class="oly-util--mb-20">
      <span class="oly-util--db oly-util--fs-20 oly-util--fw-700">Software Version</span>
      <span>
        {{ VERSION }}
        <br />
        {{ TIMESTAMP }}
      </span>
    </li>
    <li class="oly-util--mb-20">
      <span class="oly-util--db oly-util--fs-20 oly-util--fw-700">Manufacturer</span>
      <span>
        Evident Canada inc.
        <br />
        3415 rue Pierre-Ardouin
        <br />
        Québec (Québec) Canada
        <br />
        G1P 0B3
      </span>
    </li>
  </ul>

  <ng-container slot="modal-footer">
    <span class="oly-util--mr-40">{{footerMessage}}</span>
  </ng-container>
</oly-modal-view>
